module.exports = __webpack_public_path__ + "static/media/8.db85d620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/8.jpg
// module id = 95
// module chunks = 0